/*
 * @version
 * 0.01 (10.12.2019)
 * 0.02 (22.12.2019) 
 */



export class ScaleManager {
    /**
     * Udalost vyvolana pri zmene interniho rozliseni hry.
     * Parametry: w: number, h: number
     * Emitter: app
     */
    static readonly EVENT_RESIZE = "scale:resize";

    get app(): pc.Application { return this._app; }
    private _app: pc.Application;

    private _curDims: pc.Vec2;
    private _minDims: pc.Vec2;
    private _maxDims: pc.Vec2;
    private _minRatio: number;
    private _maxRatio: number;

    private _unlimitedWidth: boolean;
    private _unlimitedHeight: boolean;

    /**
     * (RO) Aktualni sirka interniho rozliseni
     */
    get width(): number { return this._curDims.x; }

    /**
     * (RO) Aktualni vyska interniho rozliseni
     */
    get height(): number { return this._curDims.y; }

    /**
     * (RO) Minimalni sirka interniho rozliseni
     */
    get minWidth(): number { return Math.min(this._minDims.x, this._maxDims.x); }

    /**
     * (RO) Maximalni sirka interniho rozliseni
     */
    get maxWidth(): number { return this._unlimitedWidth ? window.innerWidth : Math.max(this._minDims.x, this._maxDims.x); }

    /**
     * (RO) Minimalni vyska interniho rozliseni
     */
    get minHeight(): number { return Math.min(this._minDims.y, this._maxDims.y); }

    /**
     * (RO) Maximalni vyska interniho rozliseni
     */
    get maxHeight(): number { return this._unlimitedHeight ? window.innerHeight : Math.max(this._minDims.y, this._maxDims.y); }

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param scaleManager
     * @param minDims Minimalni interni rozliseni hry
     * @param maxDims Maximalni interni rozliseni hry. Pokud x <= 0, tak maximalni sirkce neni limitovana. Pokud y <= 0, tak maximalni vyska neni limitovana.
     */
    //-------------------------------------------------------------------------
    constructor(app: pc.Application, minDims: pc.Vec2, maxDims: pc.Vec2) {
        this._app = app;
        this._curDims = new pc.Vec2(0, 0);
        this._minDims = minDims;
        this._maxDims = maxDims;

        this._unlimitedWidth = this._maxDims.x <= 0;
        this._unlimitedHeight = this._maxDims.y <= 0;

        if (!this._unlimitedWidth && !this._unlimitedHeight) {
            this._minRatio = Math.min(this._minDims.x, this._maxDims.x) / Math.max(this._minDims.y, this._maxDims.y);
            this._maxRatio = Math.max(this._minDims.x, this._maxDims.x) / Math.min(this._minDims.y, this._maxDims.y);

            if (this._minRatio > this._maxRatio) {
                let i = this._minRatio;
                this._minRatio = this._maxRatio;
                this._maxRatio = i;
            }
        }

        // Zachytavat zmenu rozliseni
        window.addEventListener("resize", () => {
            this.resize();
        }, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    resize(): void {
        // Vypocitat vystupni rozliseni
        let extResW = window.innerWidth;
        let extResH = window.innerHeight;

        let intResW: number;
        let intResH: number;

        if (!this._unlimitedWidth && !this._unlimitedHeight) {
            let ratio = extResW / extResH;

            if (ratio < this._minRatio) {
                extResH = Math.floor(extResW / this._minRatio);
            }
            else if (ratio > this._maxRatio) {
                extResW = Math.floor(extResH * this._maxRatio);
            }

            // Vypocitat interni rozliseni
            intResW = extResW;
            intResH = extResH;

            if (intResW < this._minDims.x) {
                intResH = Math.round(intResH * (this._minDims.x / intResW));
                intResW = this._minDims.x;
            }
            else if (intResW > this._maxDims.x) {
                intResH = Math.round(intResH * (this._maxDims.x / intResW));
                intResW = this._maxDims.x;
            }

            if (intResH < this._minDims.y) {
                intResW = Math.round(intResW * (this._minDims.y / intResH));
                intResH = this._minDims.y;
            }
            else if (intResH > this._maxDims.y) {
                intResW = Math.round(intResW * (this._maxDims.y / intResH));
                intResH = this._maxDims.y;
            }

            intResW = Math.min(Math.max(this._minDims.x, intResW), this._maxDims.x);
            intResH = Math.min(Math.max(this._minDims.y, intResH), this._maxDims.y);
        }
        else if (this._unlimitedWidth) {
            let minH = this._minDims.y;
            let maxH = this._maxDims.y;

            if (minH > maxH) {
                minH = maxH;
                maxH = this._minDims.y;
            }

            intResH = Math.max(minH, Math.min(extResH, maxH));
            intResW = Math.round(extResW * (intResH / extResH));

            if (intResW < this._minDims.x) {
                let scale = intResW / this._minDims.x;

                intResW = this._minDims.x;
                //intResH = Math.round(intResH * scale);
                extResH = Math.round(extResH * scale);
            }
        }

        // Nastavit vystupni rozliseni
        let canvas = document.getElementById("renderCanvas");

        /*extResW = intResW;
        extResH = intResH;*/

        canvas.style.width = extResW + "px";
        canvas.style.height = extResH + "px";
        canvas.style.left = ((window.innerWidth - extResW) / 2) + "px";
        canvas.style.top = ((window.innerHeight - extResH) / 2) + "px";

        // Nastavit interni rozliseni
        if (this._curDims.x != intResW || this._curDims.y != intResH) {
            this._curDims.set(intResW, intResH);

            this._app.setCanvasResolution(pc.RESOLUTION_FIXED, intResW, intResH);
            this._app.fire(ScaleManager.EVENT_RESIZE, intResW, intResH);
        }
    }
}